import { en } from "./en";

// Language switching comes with the Portuguese version; until then everything reads English.
export const t = en;
export type { Strings } from "./en";
